import { ILocalStorageKey } from '@/types/ILocalStorageKey';
import { getLocalStorageKey } from '@/utils/getLocalStorageKey';

export const getLocalStorageValue = <T>(keyName: ILocalStorageKey): T | undefined => {
  const fullKey = getLocalStorageKey(keyName);
  const valueSerialized = localStorage.getItem(fullKey);
  if (!valueSerialized) {
    return undefined;
  }
  try {
    return JSON.parse(valueSerialized) as T;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return undefined;
  }
};
